import { useEffect, useState } from 'react';
import { ViewSidebar, type SidebarView } from '@/components/ViewSidebar';
import { legacyHref } from '@/shell/nav';
import { api } from '@/api/client';
import { useSession } from '@/stores/session';
import type { OrderPage } from '@/api/types';

const SHIPMENT_VIEWS: SidebarView[] = [
  { key: 'ready', label: '待发操作台', icon: 'truck', hot: true },
  { key: 'today', label: '今日到期', icon: 'alert', hot: true },
  { key: 'shortage', label: '缺货挂起', icon: 'box', to: '/orders?view=shortage' },
  { key: 'assembling', label: '等待组装', icon: 'set', to: '/orders?view=assembling' },
  { key: 'ledger', label: '发货批次台账', icon: 'book', separator: true },
  { key: 'exceptions', label: '批次含异常', icon: 'alert', hot: true },
  { key: 'merge', label: '按客户合单', icon: 'team', separator: true },
  { key: 'warehouse', label: '按仓库', icon: 'bank' },
];

export function ShipmentSidebar({ active, onPick, readyCount, todayCount, shortageCount, assemblingCount, mergeCount, ledgerCount, exceptionCount, warehouseCount }: { active: 'ready' | 'today' | 'merge' | 'ledger' | 'exceptions' | 'warehouse'; onPick: (key: string) => void; readyCount?: number; todayCount?: number; shortageCount?: number; assemblingCount?: number; mergeCount?: number; ledgerCount?: number; exceptionCount?: number; warehouseCount?: number }) {
  return <ViewSidebar title="发货视图" views={SHIPMENT_VIEWS.map((item) => item.key === 'ready' ? { ...item, count: readyCount } : item.key === 'today' ? { ...item, count: todayCount } : item.key === 'shortage' ? { ...item, count: shortageCount } : item.key === 'assembling' ? { ...item, count: assemblingCount } : item.key === 'merge' ? { ...item, count: mergeCount } : item.key === 'ledger' ? { ...item, count: ledgerCount } : item.key === 'exceptions' ? { ...item, count: exceptionCount } : item.key === 'warehouse' ? { ...item, count: warehouseCount } : item)} active={active} onPick={onPick} />;
}

export function useShipmentAuxCounts() {
  const can = useSession((state) => state.can);
  const canReadOrders = can('orders.read.all', 'orders.read.own', 'orders.read.assigned');
  const [shortageCount, setShortageCount] = useState<number>();
  const [assemblingCount, setAssemblingCount] = useState<number>();

  useEffect(() => {
    if (!canReadOrders) {
      setShortageCount(undefined);
      setAssemblingCount(undefined);
      return;
    }
    const controller = new AbortController();
    void api.get<OrderPage>('/api/orders', { stockStatus: 'SHORTAGE', page: 1, pageSize: 1 }, controller.signal)
      .then((page) => setShortageCount(page.pagination.total))
      .catch(() => { if (!controller.signal.aborted) setShortageCount(undefined); });
    void api.get<OrderPage>('/api/orders', { status: 'ASSEMBLING', page: 1, pageSize: 1 }, controller.signal)
      .then((page) => setAssemblingCount(page.pagination.total))
      .catch(() => { if (!controller.signal.aborted) setAssemblingCount(undefined); });
    return () => controller.abort();
  }, [canReadOrders]);
  return { shortageCount, assemblingCount };
}

export const legacyReadyOrders = () => legacyHref('/orders?stockStatus=READY');
